import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import MuiTable from "../MuiTable/MuiTable";
import { httpRequest, onRequestError, printLog } from "../../helper/global";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Email from "./Email";

export default function EmailHome({ theme, user, permissionConfig }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openEmail, setOpenEmail] = useState(false);
    const [emailLogs, setEmailLogs] = useState([]);
    const [initialSubject, setInitialSubject] = useState("");
    const [initialContent, setInitialContent] = useState("");
    const [initialRecipient, setInitialRecipient] = useState([]);

    const columns = [
        {
            id: "subject",
            label: "Subject",
            sort: true,
            visible: true,
        },

        {
            id: "dateCreated",
            label: "Date Created",
            sort: true,
            visible: true,
            order: "desc",
        },

        {
            id: "createdBy",
            label: "Created By",
            sort: true,
            visible: true,
        },
    ];

    const handleEmailResults = (result) => {
        if (result === false) {
            return;
        }

        setEmailLogs(result);
    };

    const fetchEmails = async () => {
        try {
            const result = await httpRequest(
                `email/logs`,
                {},
                "GET",
                (error) => {
                    onRequestError(dispatch, navigate, {
                        title: error.title,
                        message: error.message,
                    });
                }
            );

            if (result === false) {
                return;
            }

            handleEmailResults(result.payload);
        } catch (error) {
            console.error("Error fetching email logs:", error);
        }
    };

    useEffect(() => {
        fetchEmails();
    }, []);

    return (
        <>
            <Box sx={{ p: 3 }}>
                <Box>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenEmail(true);
                            setInitialSubject("");
                            setInitialContent(``);
                            setInitialRecipient([]);
                        }}
                    >
                        New Email
                    </Button>
                    <Box sx={{ mt: 3 }}>
                        <MuiTable
                            allowSearch={false}
                            theme={theme}
                            id={"templateId"}
                            headCells={columns}
                            defaultData={emailLogs}
                            defaultSortIndex={1}
                            rowsPerPageArray={[50, 100, 200]}
                            onSelectRow={(row) => {
                                setOpenEmail(true);
                                setInitialSubject(row.subject);
                                setInitialContent(row.content);
                                setInitialRecipient(row.recipient);
                            }}
                        />
                    </Box>
                </Box>

                <Email
                    theme={theme}
                    isOpen={openEmail}
                    onClose={() => setOpenEmail(false)}
                    initialSubject={initialSubject}
                    initialContent={initialContent}
                    initialRecipient={initialRecipient}
                    updateEmailResults={handleEmailResults}
                />
            </Box>
        </>
    );
}
